<script setup>
import { Link } from "@inertiajs/vue3";

/**
 * "Confirmed For Me" / "Confirmed By Me" toggle inside the Confirmed Gifts
 * section header (GH-878, per Figma). The secondary nav carries a single
 * "Confirmed Gifts" entry; this switches between the two views.
 */
defineProps({
    active: {
        type: String,
        required: true, // "for-me" | "by-me"
    },
});

const tabs = [
    { key: "for-me", label: "Confirmed For Me", routeName: "gifts.for_you" },
    { key: "by-me", label: "Confirmed By Me", routeName: "gifts.by_you" },
];
</script>

<template>
    <nav
        class="flex items-center gap-6 whitespace-nowrap font-brand text-[15px] font-semibold lg:gap-8"
    >
        <Link
            v-for="tab in tabs"
            :key="tab.key"
            :href="route(tab.routeName)"
            class="border-b-2 border-solid pb-1.5 text-[#102a3d]"
            :class="
                active === tab.key
                    ? 'border-brand-red'
                    : 'border-transparent transition hover:text-brand-red'
            "
        >
            {{ tab.label }}
        </Link>
    </nav>
</template>
